// MpfRadios.props.ts
import type { HeadingLevel } from '../MpfInput/MpfInputBaseProps';
import { HeadingLevelSize, MpfInputBaseProps } from '../MpfInput/MpfInputBaseProps';

export interface MpfRadioDividerItem {
  type: 'divider';
  label: string;
}

export interface MpfRadioOptionItem {
  type: 'radio';
  value: string | number | null;
  label: string;
  id?: string;
  disabled?: boolean;
}

export type MpfRadioItem = MpfRadioDividerItem | MpfRadioOptionItem;

export interface MpfRadiosProps
  extends Omit<MpfInputBaseProps, 'headingLevelSize' | 'headingLevel' | 'modelValue' | 'errors'> {
  type?: 'radios';
  modelValue: string | number | null;
  legend?: string;
  legendHeadingLevel?: HeadingLevel;
  legendHeadingSize?: HeadingLevelSize;
  items: MpfRadioItem[];
  errors?: string[];
}

export const mpfRadiosDefaults = {
  modelValue: null,
  type: 'radios',
  // @ts-expect-error
  errors: () => [] as string[],
} satisfies Partial<MpfRadiosProps>;

export type MpfRadiosEmits = {
  (e: 'update:modelValue', value: string | number | null): void;
  (e: 'change', value: string | number | null, event: Event): void;
  (e: 'blur', event: FocusEvent): void;
};
